<template>
  <div>
    {{msg}}
  </div>
</template>

<script>
export default {
  name: 'monev_ver_instrumen_verifikasi_dapodik_smk',
  data: function(){
    return {
      msg : 'ver_ instrumen verifikasi dapodik SMK'
    }
  }
}
</script>

<style>

</style>
